module.exports = __webpack_public_path__ + "static/img/sexual_violence.231a07b3.png";